import React from "react";
import "./TextArea.css";

const TextArea = ({ label, error, onChange, name, required, ...props }) => {

  const handleChange = (e) => {
    if (onChange) onChange(e);
  };

  return (
    <div className="textarea-group">
      {label && (
        <label className="textarea-label">
          {label}{required && <span className="required-star"> *</span>}
        </label>
      )}

      <textarea
        className="textarea-control"
        name={name}
        required={required}
        onChange={handleChange}
        {...props}
      />

      {error && <p className="textarea-error">{error}</p>}
    </div>
  );
};

export default TextArea;
